<template>
  <div>
    <template v-if="selectedFlag">
      <shipblu-button size="small" :textButton="`${$t('Download')} (${selected.length})`" :iconStyle="{iconPosition:'left', LeftIconName: 'DownloadIcon', LeftIconLibrary: 'feather'}" @click="downloadShipments()" class="w-full"/>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select order you want to download!')}`">
        <shipblu-button size="small" :textButton="$t('Download')" :iconStyle="{iconPosition:'left', LeftIconName: 'DownloadIcon', LeftIconLibrary: 'feather'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
import common from '@/assets/utils/common'

export default {
  props: ['selected'],
  data () {
    return {
      headerTitle: ['Order ID', 'Created On', 'Linked Tracking Number', 'Products', 'Location', 'Merchant Name', 'Customer Name', 'Customer Phone', 'No. of Items', 'Status'],
      headerVal: ['id', 'created', 'linkedTrackingNumber', 'products', 'location', 'merchant', 'customerInfo', 'customerPhone', 'numberOfItems', 'status'],
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    downloadShipments () {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.selected
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: 'Shipments',
          autoWidth: true
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        switch (j) {
        case 'created':
          return v[j] ? new Date(v[j]).toLocaleDateString('fr-CA') : ''
        case 'linkedTrackingNumber':
          if (v.customer && v.customer.address && v.customer.address.shipping_provider_metadata &&
            v.customer.address.shipping_provider_metadata.shipblu &&
            v.customer.address.shipping_provider_metadata.shipblu.order &&
            v.customer.address.shipping_provider_metadata.shipblu.order.tracking_number) {
            return v.customer.address.shipping_provider_metadata.shipblu.order.tracking_number
          }
          return 'N/A'
        case 'products':
          return Array.isArray(v.products) ? v.products.map(item => `${item.product ? item.product.sku : ''} (${item.quantity})`).join(', ') : ''
        case 'location':
          return Array.isArray(v.products) ? v.products.map(item => item.product.locations && item.product.locations.length > 0 && item.product.locations.map(location => `[${location.location}] [${location.stored_quantity}]`).join(', \n')) : ''
        case 'merchant':
          return v[j] ? v[j].name : ''
        case 'customerInfo':
          return v.customer ? v.customer.full_name : ''
        case 'customerPhone':
          return v.customer ? v.customer.phone : ''
        case 'numberOfItems':
          return v.number_of_items !== null ? v.number_of_items : ''
        case 'status':
          return common.getStatusLabel(v, this.$store.state.AppActiveUser.userRole)
        }
        return v[j]
      }))
    }
  }
}
</script>
